import { useState } from 'react';
import BlankSpace from './BlankCell';

const DateTimeInput = ({
  defaultValue,
  onChange,
  disabled = false,
  className = "",
  dateFormatFn = defaultFormatDate
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(defaultValue);
  const [editValue, setEditValue] = useState(defaultValue);

  const handleBlur = () => {
    if (editValue !== value) {
      onChange(editValue);
      setValue(editValue);
    }
    setIsEditing(false);
  };

  const handleChange = (e) => {
    if (e.target.value === "") {
      setEditValue(null);
      return;
    }
    setEditValue(e.target.value);
  };

  const getCurrentDate = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  };

  const getInputValue = () => {
    if (value) return value;
    const now = new Date();
    return `${getCurrentDate()}-${String(now.getDate()).padStart(2, '0')}T${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
  };

  return (
    <div className={className}>
      {isEditing && !disabled ? (
        <input
          type="datetime-local"
          defaultValue={getInputValue()}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyDown={(e) => e.key === 'Enter' && handleBlur()}
          autoFocus
          className="form-control"
          style={{ width: "100%" }}
        />
      ) : (
        <div
          onClick={() => !disabled && (setEditValue(value), setIsEditing(true))}
          style={{
            cursor: disabled ? 'default' : 'pointer',
            padding: "5px",
            borderRadius: "4px",
            border: "1px solid transparent",
            opacity: disabled ? 0.7 : 1,
            ...(!disabled && { ':hover': { borderColor: "#ddd" } })
          }}
        >
          {value ? dateFormatFn(value) : <BlankSpace />}
        </div>
      )}
    </div>
  );
};

const defaultFormatDate = (datetimeString) => {
  const date = new Date(datetimeString);
  const month = date.toLocaleString('en-US', { month: 'short' });
  const day = date.getDate();
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;

  return (
    <div style={{ 
      display: 'flex',
      flexDirection: 'column',
      lineHeight: '1.2',
      gap: '2px'
    }}>
      <span style={{ whiteSpace: 'nowrap' }}>
        {month} {day}
      </span>
      <span style={{ 
        whiteSpace: 'nowrap',
        fontSize: '0.9em',
        color: '#555'
      }}>
        {hours}:{minutes}{ampm}
      </span>
    </div>
  );
};

export default DateTimeInput;